import { formatUpdatedTime } from '../utils/datetime.js'

/**
 * Compact "Updated HH:MM" label for franchise/activity cards.
 * Renders nothing when the timestamp is absent or unparseable.
 */
export default function UpdatedLabel({ timestamp }) {
  const time = formatUpdatedTime(timestamp)
  if (!time) return null
  return <span className="venue-updated">Updated {time}</span>
}
